import React from 'react'
import Header from '../Components/Header';
import Divider from './../Images/divider.png';
import GroupImg from './../Images/group-img.png';
import DotsTheme from './../Images/dots-theme.png';
import BigImg from './../Images/big-img.png';
import SmallImg from './../Images/small-img.png';
import Footer from '../Components/Footer';
import frame from './../Images/frame.png';

const Invest = () => {
    return (
        <>
            <Header />

            <div className="pt-150">
                <div className="container mb-5">
                    <div className="main-title-3 ">
                        <span className='divider'><img src={Divider} alt="" /></span>
                        <h1>Invest in Real Estate with VISTAPLOTS</h1>
                        <p>Investing in the Real Estate is the best choice of the Investment compared to the any other Investment option in India. Real Estates has shown 205% of the Increase in the pricing for the last 10 years of period. Investing in the Real Estate has high return of the investment compared to the Equity Investments. Rental Income obtained from the Residential and Commercial Property can be a dividend for your Investment. </p>

                    </div>
                </div>
                <div className="dots-rel  mb-200">
                <div className="dots-theme">
                            <img src={DotsTheme} alt="" />
                        </div>
                        <div className="dots-theme-2">
                            <img src={DotsTheme} alt="" />
                        </div>
                    <div className="container position-rel">
                        
                        <div className="about-img-large mb-4">
                            <img src={GroupImg} alt="" />
                        </div>
                        <div className="about-img-small mb-4">
                            <img src={GroupImg} alt="" />
                        </div>
                        

                    </div>
                </div>
                <div className="container mb-70">
                    <div className="main-title-3">

                        <p>VISTAPLOTS has flexible investment options to Invest in the Real Estate Segment starting from the 10,000 Rs/- Onwards. Are you Looking to Buy a Plot/Land anywhere in Bangalore? Why not start to Invest your money today in VISTAPLOTS. You Invest your money consistently month on month basis in VISTAPLOTS which will have a good return of 50% to 200% within a Span of 36 Months to 60 Months of Time period. You can encash your Investment to buy the Best Plots in Bangalore. </p><p></p><br />
                        <p>Are you an NRI (Non-Resident Indian)? Are you Looking for a good option to buy the Land/Plot with your savings? Are you having too much of expenses that you cannot Invest one time? Is your EMI having more Interest which is double your Loan? Never worry, VISTAPLOTS is a hassle-free investment option for buying of the Plots with the regular monthly Investment or one time investment which can have a return of Investment UPTO 100% within 36 months of time. </p><p></p><br />
                        <p>Covid-19 has literally changed the lives of the billions of the people across India. The earrings of the common man have been affected a lot more. A steady own home is a lot more comfort for any family than being at a rental home in India. The Pain of paying the rent irrespective of the economic crisis of a common man is an untold story. This Covid-19 has brought an uncertain environment in the lives of many. This is the right time to Invest your money to buy a Land or Plot with VISTAPLOT which provides hassle free Plot purchasing option with the Invested amount in 36 TO 60 months of time.
                        </p><p></p><br />
                        <p>Buy your Land/Plot either for constructing your own house or constructing a commercial building. Investing in the Best Performing asset such as Commercial Real Estate has yielded a good return of the Investment for many Investors for the past 50 Plus years. 10% of the Rental Yield is obtained on the Commercial Real Estate Investment. Investing in the Commercial Real Estates properties through the VISTAPLOTS has become budget friendly and the viable option. </p>
                        <p>Own a Commercial Property by Investing in VISTAPLOTS.
                        </p>

                    </div>
                </div>
                <div className="container mb-70">
                    <div className="main-title-3 ">
                        <span className='divider'><img src={Divider} alt="" /></span>
                        <h1>Return on the Investment </h1>
                        <p>Investing in the VISTAPLOTS would yield a Return on the Investment of 50% to 200% within a time span of 36 months to 60 months of time. With the Rise in the Demand for the Commercial Office Spaces, VISTAPLOTS is also moving to expand their base across all the tier1 cities of India. Potential Commercial Locations Include Land/Plots for the Industrial/Manufacturing Unit Land, Retail Showroom/Mall Land, Parking Spaces and Educational Institutions, Movie Theatres and More. Investing in the Commercial Property provides a Stable and Good Source of the Income compared to the Residential Land Investments. The Tenure of the Commercial tenants are usually 10 to 20 years of time frame where the owner of the property can have a peace of mind when his/her financial incomes are good through their commercial property. </p>
                    </div>
                </div>
                <div className="container mb-70">
                    <div className="main-title-3 ">
                        <span className='divider'><img src={Divider} alt="" /></span>
                        <h1>Appreciation Value of the Land</h1>
                        <p>Investing in the Commercial Property has provided a good appreciation value compared to the Investment in the Residential Investments. Commercial Investment can go up to 300% more compared to the Residential Investments in a time span of 10 years of time. </p>
                    </div>
                </div>
                <div className="container mb-70">
                    <div className="main-title-3 ">
                        <span className='divider'><img src={Divider} alt="" /></span>
                        <h1>Property Taxes for the Commercial Land</h1>
                        <p>The Property Tax are considered as the “Income Tax from the Other Sources” as the rent received from the other sources.  The BBMP’s Tenanted property tax for Zone A is 20 Rs/- Per Sq. Ft and 14 Rs/- Per Sq. Ft for Zone B. The Self Occupied property tax would be 10 Rs/- Per Sq. Ft for Zone A and 7 Rs/- Per Sq. Ft for Zone B.</p>
                    </div>
                </div>
            </div>


            {/* numbers starts */}
            <div className="num-bg mb-60" style={{ backgroundImage: `url(${frame})` }}>
                <div className="container">
                    <div className="row">

                        <div className="col-lg-3 col-md-6 mb-lg-0 mb-4">
                            <div className="num text-center">
                                <h3>2028</h3>
                                <p>lorem ipsum</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 mb-lg-0 mb-4">
                            <div className="num text-center">
                                <h3>33</h3>
                                <p>lorem ipsum</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 mb-lg-0 mb-4">
                            <div className="num text-center">
                                <h3>400</h3>
                                <p>lorem ipsum</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 mb-lg-0 mb-4">
                            <div className="num text-center">
                                <h3>133</h3>
                                <p>lorem ipsum</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* numbers ends */}
            <div className=" mb-70">
                <div className="container">
                    <div className="row">

                        <div className="col-lg-6">
                            <div className="main-title-3 pe-4">
                                <span className='divider text-start'><img src={Divider} alt="" /></span>
                                <h1 className='text-start'>Benefits of the Investing in VISTAPLOTS</h1>
                                <p>•	Hassle Free Monthly Investments starting from 10,000 Rs/- Onwards.</p>
                                <p>•	One-Time Investment which can be appreciated from 50% to 200% within a Span of 36 Months to 60 Months of time. </p>
                                <p>•	You will receive the contract signed both in Hardcopy and Softcopy for your Invested amount in VISTAPLOTS. </p>
                                <p>•	You can encash your Investment to buy the Residential and Commercial Plots/Land within a Span of 36 Months to 60 Months of time. </p>
                                <p>•	Our Legal Team will be providing you the comfortable background and legal checks along with the encumbrance certificate checks before you encash your Investments to buy the Commercial or Residential Land.</p>
                                <p>•	Enjoy the benefits of buying the property without Investing your complete savings at once. </p>
                                <p>Connect with us to Invest in VISTAPLOTS.

                                </p>
                            </div>

                        </div>
                        <div className="col-lg-6">
                            <div className="double-imgs ps-30 pt-lg-5 pt-0">
                                <div className="big-img">
                                    <img src={BigImg} alt="" />
                                </div>
                                <div className="small-img">
                                    <img src={SmallImg} alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    )
}

export default Invest